module.exports = __webpack_public_path__ + "img/10_no.4cd73523.svg";